export default {"src":"/_next/static/media/truth-social-dark.1b2eaa3e.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};